// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"94ed59b0","213":"98fa92c0","239":"2fe5f0c4","450":"1cc10c20","732":"d44c7bc0","867":"49e5a176"}[chunkId] + ".chunk.js";
};